import { render } from "./Repo.vue?vue&type=template&id=367441cc&scoped=true"
import script from "./Repo.vue?vue&type=script&lang=js"
export * from "./Repo.vue?vue&type=script&lang=js"

import "./Repo.vue?vue&type=style&index=0&id=367441cc&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367441cc"]])

export default __exports__